module.exports = __webpack_public_path__ + "static/media/dimensionStandard3.134a130b.png";